export default __webpack_public_path__ + "static/media/botoes_genericos_01.dbfb0d83.mp3";